// Property images
import pool from "assets/images/property/pool.webp";
import pool2 from "assets/images/property/pool2.webp";
import poolSunset from "assets/images/property/pool-sunset-vertical.webp";
import frontYard from "assets/images/property/Front yard best picture.webp";
import frontPorch from "assets/images/property/front-porch.webp";
import frontPorchSide from "assets/images/property/front-porch-side-view.webp";
import porchFoodSpread from "assets/images/property/porch-food-spread.webp";
import porchSeating from "assets/images/property/porch-seating-area.webp";
import tableWithView from "assets/images/property/table-with-view.webp";
import kitchen from "assets/images/property/kitchen.webp";
import jacuzzi from "assets/images/property/jacuzzi.webp";
import livingRoom from "assets/images/property/living-room.webp";
import hallwayComputer from "assets/images/property/hallway-with-computer.webp";
import highSpeedInternet from "assets/images/property/high-speed-internet.webp";
import houseToPoolStairs from "assets/images/property/house-to-pool-stairs.webp";
import gaziboArea from "assets/images/property/gazibo-area.webp";
import gaziboAreaPool from "assets/images/property/gazibo-area-pool.webp";
import grassArea from "assets/images/property/property-grass-area.webp";
import niceTrees from "assets/images/property/nice-trees-on-property.webp";
import monkeyOnProperty from "assets/images/property/monkey-on-property.webp";
import sunsetView from "assets/images/property/sunset-view.webp";
import view from "assets/images/property/view.webp";
import pingPong from "assets/images/property/ping-pong-table.webp";
import propertyKayaks from "assets/images/property/property-kayaks.webp";
import laundryArea from "assets/images/property/laundry-area.webp";
import kingRoom from "assets/images/property/king-room-vertical.webp";
import kingRoomDresser from "assets/images/property/king-room-dresser.webp";
import queenRoom from "assets/images/property/queen-room.webp";
import queenRoom2 from "assets/images/property/queen-room2.webp";
import roomDoubleBed from "assets/images/property/room-doublebed.webp";
import roomDresser from "assets/images/property/room-dresser.webp";
import doubleTwins from "assets/images/property/double-twins-room.webp";
import bunkBeds from "assets/images/property/bunk-beds.webp";
import bathroom1 from "assets/images/property/bathroom1.webp";
import bathroom2 from "assets/images/property/bathroom2.webp";
import bathroom3 from "assets/images/property/Bathroom3-2023.webp";
import cookBreakfast from "assets/images/property/cook-breakfast.webp";
import cookDinner from "assets/images/property/cook-dinner.webp";

// Beach images
import beachDrone from "assets/images/beaches/our-beach-drone-pic.webp";
import beachSunset from "assets/images/beaches/our-beach-sunset.webp";
import beachRocks from "assets/images/beaches/our-beach-rocks.webp";
import beachRocks2 from "assets/images/beaches/our-beach-rocks2.webp";
import beach4x4 from "assets/images/beaches/our-beach-4x4-tour.webp";
import beachKayakTo from "assets/images/beaches/beach-you-can-kayak-to.webp";
import whiteSand from "assets/images/beaches/neighboring-white-sand.webp";
import whiteSandBeach from "assets/images/beaches/neighboring-white-sand-beach.webp";
import whiteSandBeach2 from "assets/images/beaches/neighboring-white-sand-beach2.webp";
import kayaktrails from "assets/images/beaches/kayak-trails.webp";

// Activity images
import kayakFromBeach from "assets/images/activities/kayak-from-our-beach.webp";
import atvTour from "assets/images/activities/atv-tour.webp";
import horsebackTour from "assets/images/activities/horseback-tour.webp";
import ziplineTour from "assets/images/activities/zipline-tour.webp";
import ziplineView from "assets/images/activities/zipline-tour-view.webp";
import crocTourFeeding from "assets/images/activities/Crocodile-tour_Man_feeding.webp";
import crocTourBird from "assets/images/activities/crocodile-tour-bird.webp";
import crocTourBoat from "assets/images/activities/crocodile-tour-boat.webp";
import crocTourCroc from "assets/images/activities/crocodile-tour-croc.webp";
import sailfish from "assets/images/activities/tony-and-sailfish-2.webp";

const photosData = {
  property: {
    title: "The House & Property",
    description: "6-bedroom beachfront home with pool, game room, and tropical grounds",
    photos: [
      // --- Column 1: Exterior, Pool & Views ---
      {
        src: pool,
        alt: "Swimming Pool",
        description: "Our private swimming pool with ocean views.",
        featured: false,
        hero: true,
      },
      {
        src: frontYard,
        alt: "Front yard view",
        description: "The beautiful front yard overlooking the ocean.",
        featured: true,
      },
      {
        src: jacuzzi,
        alt: "Jacuzzi",
        description: "Large 6-8 person jacuzzi to relax and watch the sunset.",
        featured: true,
      },
      {
        src: kitchen,
        alt: "Kitchen",
        description: "Fully equipped kitchen for preparing meals.",
        featured: true,
      },
      {
        src: poolSunset,
        alt: "Pool at sunset",
        description: "The pool during a beautiful Costa Rica sunset.",
        featured: false,
      },
      {
        src: livingRoom,
        alt: "Living room",
        description: "Spacious living room interior.",
        featured: true,
      },
      {
        src: gaziboArea,
        alt: "Gazebo area",
        description: "Shaded gazebo area for relaxing.",
        featured: true,
      },
      {
        src: sunsetView,
        alt: "Sunset view",
        description: "Stunning sunset view from the property.",
        featured: false,
      },
      {
        src: frontPorch,
        alt: "Front porch",
        description: "The front porch with tropical landscaping.",
        featured: false,
      },
      {
        src: pool2,
        alt: "Pool area",
        description: "Another view of the pool and surrounding area.",
        featured: false,
      },
      {
        src: niceTrees,
        alt: "Tropical trees on property",
        description: "Beautiful tropical trees throughout the property.",
        featured: false,
      },
      {
        src: view,
        alt: "Ocean view",
        description: "Ocean view from the property.",
        featured: false,
      },
      {
        src: porchFoodSpread,
        alt: "Porch food spread",
        description: "Fresh food spread on the front porch dining area.",
        featured: true,
      },
      {
        src: kingRoom,
        alt: "King bedroom",
        description: "King bedroom with comfortable furnishings.",
        featured: false,
      },
      {
        src: frontPorchSide,
        alt: "Front porch side view",
        description: "Side view of the spacious front porch.",
        featured: false,
      },
      // --- Column 2: Porch, Interior & Bedrooms ---
      {
        src: porchSeating,
        alt: "Porch seating area",
        description: "Comfortable seating area on the porch.",
        featured: false,
      },
      {
        src: tableWithView,
        alt: "Dining table with view",
        description: "Outdoor dining table with an ocean view.",
        featured: false,
      },
      {
        src: houseToPoolStairs,
        alt: "House to pool stairs",
        description: "Stairs leading from the house down to the pool.",
        featured: false,
      },
      {
        src: grassArea,
        alt: "Property grass area",
        description: "Open grass area on the property grounds.",
        featured: false,
      },
      {
        src: hallwayComputer,
        alt: "Hallway with computer",
        description: "Hallway area with an iMac computer available for guests.",
        featured: false,
      },
      {
        src: kingRoomDresser,
        alt: "King bedroom dresser",
        description: "King bedroom with dresser and storage.",
        featured: false,
      },
      {
        src: queenRoom,
        alt: "Queen bedroom",
        description: "Queen bedroom with cozy decor.",
        featured: false,
      },
      {
        src: queenRoom2,
        alt: "Second queen bedroom",
        description: "Another queen bedroom option.",
        featured: false,
      },
      {
        src: bathroom1,
        alt: "Bathroom",
        description: "Clean and modern bathroom.",
        featured: false,
      },
      {
        src: roomDoubleBed,
        alt: "Double bed room",
        description: "Room with a comfortable double bed.",
        featured: false,
      },
      {
        src: roomDresser,
        alt: "Bedroom with dresser",
        description: "Bedroom with dresser and storage space.",
        featured: false,
      },
      {
        src: gaziboAreaPool,
        alt: "Gazebo area by the pool",
        description: "Gazebo area with a view of the pool.",
        featured: false,
      },
      // --- Column 3: More Bedrooms, Bathrooms, Wildlife & Services ---
      {
        src: doubleTwins,
        alt: "Double twins room",
        description: "Room with two twin beds.",
        featured: false,
      },
      {
        src: bunkBeds,
        alt: "Bunk beds",
        description: "Bunk bed room, great for kids.",
        featured: false,
      },
      {
        src: bathroom2,
        alt: "Second bathroom",
        description: "Another fully equipped bathroom.",
        featured: false,
      },
      {
        src: monkeyOnProperty,
        alt: "Monkey on property",
        description: "Local wildlife visiting the property.",
        featured: false,
      },
      {
        src: bathroom3,
        alt: "Third bathroom",
        description: "Updated bathroom with modern fixtures.",
        featured: false,
      },
      {
        src: pingPong,
        alt: "Ping pong table",
        description: "Ping pong table for guest entertainment.",
        featured: false,
      },
      {
        src: propertyKayaks,
        alt: "Kayaks on property",
        description: "Seven kayaks available for guest use.",
        featured: false,
      },
      {
        src: highSpeedInternet,
        alt: "High speed internet",
        description: "High speed 98 Mbps internet available throughout the property.",
        featured: false,
      },
      {
        src: laundryArea,
        alt: "Laundry area",
        description: "On-site laundry area for guest use.",
        featured: false,
      },
      {
        src: cookBreakfast,
        alt: "Cook preparing breakfast",
        description: "Our cook preparing a fresh breakfast for guests.",
        featured: false,
      },
      {
        src: cookDinner,
        alt: "Cook preparing dinner",
        description: "Dinner preparation by our on-site cook.",
        featured: false,
      },
    ],
  },
  beaches: {
    title: "Local Beaches",
    description: "Direct beach access and stunning coastline just steps from the property",
    photos: [
      {
        src: beachDrone,
        alt: "Our beach aerial view",
        description: "Drone shot of our beautiful beachfront.",
        featured: true,
      },
      {
        src: beachSunset,
        alt: "Beach sunset",
        description: "A gorgeous sunset on our beach.",
        featured: true,
      },
      {
        src: beachRocks,
        alt: "Beach rocks",
        description: "Rocky coastline along our beach.",
        featured: false,
      },
      {
        src: beachRocks2,
        alt: "Beach rocks view",
        description: "Another view of the rocky shoreline.",
        featured: false,
      },
      {
        src: beach4x4,
        alt: "Beach 4x4 tour",
        description: "4x4 tour along the beach.",
        featured: false,
      },
      {
        src: beachKayakTo,
        alt: "Beach you can kayak to",
        description: "A beautiful beach reachable by kayak from the property.",
        featured: false,
      },
      {
        src: whiteSand,
        alt: "Neighboring white sand beach",
        description: "White sand beach just a short distance away.",
        featured: false,
      },
      {
        src: whiteSandBeach,
        alt: "White sand beach",
        description: "Stunning neighboring white sand beach.",
        featured: false,
      },
      {
        src: whiteSandBeach2,
        alt: "White sand beach view",
        description: "Another view of the nearby white sand beach.",
        featured: false,
      },
      {
        src: kayaktrails,
        alt: "Neighboring Beaches you can kayak to",
        description:
          "Two white sand beaches and a beautiful hidden beach with a waterfall you can kayak to from our place.",
        featured: false,
      },
    ],
  },
  activities: {
    title: "Activities & Tours",
    description: "Surfing, kayaking, zip-lining, wildlife tours, and more — all nearby",
    photos: [
      {
        src: kayakFromBeach,
        alt: "Kayaking from our beach",
        description: "Kayaking directly from our beachfront.",
        featured: true,
      },
      {
        src: atvTour,
        alt: "ATV tour",
        description: "ATV tour through the Costa Rica countryside.",
        featured: true,
      },
      {
        src: horsebackTour,
        alt: "Horseback riding tour",
        description: "Horseback riding tour through the local area.",
        featured: false,
      },
      {
        src: ziplineTour,
        alt: "Zipline tour",
        description: "Zip-lining through the rainforest canopy.",
        featured: false,
      },
      {
        src: ziplineView,
        alt: "Zipline tour view",
        description: "Incredible views from the zipline tour.",
        featured: false,
      },
      {
        src: crocTourFeeding,
        alt: "Crocodile tour feeding",
        description: "Crocodile tour — watching the feeding up close.",
        featured: false,
      },
      {
        src: crocTourBird,
        alt: "Crocodile tour bird",
        description: "Exotic birds spotted on the crocodile river tour.",
        featured: false,
      },
      {
        src: crocTourBoat,
        alt: "Crocodile tour boat",
        description: "Boat ride on the crocodile river tour.",
        featured: false,
      },
      {
        src: crocTourCroc,
        alt: "Crocodile tour crocodile",
        description: "A crocodile spotted during the river tour.",
        featured: false,
      },
      {
        src: sailfish,
        alt: "Deep sea fishing sailfish",
        description: "Deep sea fishing — catching a sailfish off the coast.",
        featured: false,
      },
    ],
  },
};

// Flat array of all photos (used for lightbox navigation)
export const allPhotos = [
  ...photosData.property.photos,
  ...photosData.beaches.photos,
  ...photosData.activities.photos,
];

// Section keys in display order
export const sections = ["property", "beaches", "activities"];

export default photosData;
